import { render, staticRenderFns } from "./alter-quotes-version.vue?vue&type=template&id=de227fe6&scoped=true&"
import script from "./alter-quotes-version.vue?vue&type=script&lang=js&"
export * from "./alter-quotes-version.vue?vue&type=script&lang=js&"
import style0 from "./alter-quotes-version.vue?vue&type=style&index=0&id=de227fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de227fe6",
  null
  
)

export default component.exports